<!--SKU编辑  -->
<template>
	<div class="dialogBox">
		<el-dialog title="添加客商" v-if="dialogVisible" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="800px" :before-close="cancle">
			<span slot="title" class="flex flex-middle">
				<div class="title">添加客商</div>
				<div class="flex ml15">
					<el-input v-model.trim="agentName" class="w190" size="small" placeholder="客商名称" maxlength="16"
						clearable>
					</el-input>
					<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearch" alt="">
				</div>
			</span>
			<div class="form-box">
				<el-table class="" ref="multipleTable" :row-key="(row)=>{ return row.agentId}" :data="tableData"
					v-el-table-infinite-scroll="tableLoad" height="300" @selection-change="handleSelectionChange"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}" border
					style="width: 100%">
					<el-table-column type="selection" :reserve-selection="true" width="55">
					</el-table-column>
					<el-table-column prop="agentCode" label="客商编号">
					</el-table-column>
					<el-table-column prop="agentName" label="客商名称">
					</el-table-column>
					<el-table-column prop="settlementType" label="结算方式">
						<template slot-scope="scope">
							{{settlementType[scope.row.settlementType]}}
						</template>
					</el-table-column>
				</el-table>

			</div>
			<span slot="footer" class="dialog-footer mt10">
				<el-button size="small" @click="cancle()">取 消</el-button>
				<el-button size="small" type="primary" @click="submitForm()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		debounce
	} from '@/utils/debounce'
	export default {
		data() {
			return {
				dialogVisible: false,
				agentName: "",
				tableData: [],
				pageNo: 1,
				pageSize: 20,
				totalPage: 0,
				multipleSelection: [],
				settlementType: {
					'0': '现金',
					'1': '账期',
					'2': '其它',
					'9': '自贩'
				},
				newFlag: "",
				planId: '',
				groupId: "",
				infiniteFlag: false,
			}
		},
		created() {

		},
		methods: {
			init(planId, groupId) {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.infiniteFlag = false
					this.planId = planId
					this.agentName = ""
					this.groupId = groupId
					this.pageNo = 1
					this.getAgentList()
				})
			},

			//  获取列表
			getAgentList(type) {
				if(this.infiniteFlag) {
					return
				}
				let that = this;
				that.$request.post(
						"busAgentList",
						false, {
							pageNo: that.pageNo,
							pageSize: that.pageSize,
							agentName: that.agentName,
							newFlag: "N",
							groupId: that.groupId
						}
					)
					.then((res) => {
						if(res.data) {
							that.infiniteFlag = res.data.totalPage <= that.pageNo;
							}
						if (type == 'scroll') {
							that.tableData = that.tableData.concat(res.data && res.data.list || []);
						} else {
							if (res.data && res) {
								that.tableData = res.data.list
							} else {
								that.tableData = []
							}
						}

					})
			},
			// 表格滚动加载
			tableLoad: debounce(function () {
				this.pageNo++;
				this.getAgentList('scroll');
			}, 100, true),
			// 当前页切换
			handleCurrentChange(val) {
				this.pageNo = val;
				this.getAgentList();
			},
			// 搜索
			handleSearch() {

				this.pageNo = 1;
				this.infiniteFlag = false;
				this.getAgentList();
				if (this.tableData.length > 0) {
					this.$refs.multipleTable.clearSelection();
					this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
				}

			},
			// 列多选
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},

			// 保存
			submitForm: debounce(function () {
				let that = this
				if (that.multipleSelection.length <= 0) {
					this.$message.error('请先选择!');
					return
				}
				that.addRow()
			}, 1000, true),
			// 新增
			addRow() {
				let that = this;
				let agentIds = []
				this.multipleSelection.forEach(item => {
					agentIds.push(item.agentId)
				});
				that.$request.post(
						"roundPlanAddAgent",
						true, {
							planId: that.planId,
							agentIds: agentIds
						}
					)
					.then((res) => {
						if (res) {
							that.dialogVisible = false
							that.$message.success("保存成功！");
							that.$emit("getAgentList")
						}
					})
			},
			// 取消
			cancle() {
				this.dialogVisible = false
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.dialogBox {

		/deep/ .el-dialog__body {
			padding: 0px 10px;
		}

		/deep/ .el-radio .el-radio__label {
			display: none;
		}
	}

	.el-dialog__body {
		height: 500px;
	}

	.el-table {

		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 5px;
		}

		/deep/ td {
			padding: 5px;
		}

	}

</style>
